module.exports = __webpack_public_path__ + "media/images/landkit/devices/iphonex-643e73998f2b97ba6eae7ecea3017d7c.svg";